import AppIcon from "../components/AppIcon";
export default function Spinner({ className = "w-4 h-4" }) {
  return <AppIcon code="fa-spinner" className={`animate-spin ${className}`} />;
}
